import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';

export function initThreeJS(canvas) {
    /**
     * Base
     */
    // Scene
    const scene = new THREE.Scene();

    /**
     * Sizes
     */
    const sizes = {
        width: 0,
        height: 0,
    };


    /**
     * Camera
     */
    // Base camera
    const camera = new THREE.PerspectiveCamera(
        50,
        sizes.width / sizes.height,
        0.1,
        100,
    );
    camera.position.x = 1;
    camera.position.y = 1;
    camera.position.z = 2;
    scene.add(camera);

    /**
     * Lights
     */
    // Ambient light
    const ambientLight = new THREE.AmbientLight('#ffbda8', 1); // color, intensity
    scene.add(ambientLight);

    const light1 = new THREE.DirectionalLight(0xffffff, 1);
    light1.position.set(5, 10, 5);
    scene.add(light1);

    /**
     * Textures
     */
    const textureLoader = new THREE.TextureLoader();
    const matcapTexture = textureLoader.load('/textures/matcaps/8.png');
    matcapTexture.colorSpace = THREE.SRGBColorSpace;


    textureLoader.load('/textures/environmentMap/space.jpg', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        texture.colorSpace = THREE.SRGBColorSpace; 
        
        scene.background = texture;
    });

    /**
     * Fonts
     */
    const fontLoader = new FontLoader();

    fontLoader.load('/fonts/NotoSansJP-Regular.typeface.json', (font) => {
        const textGeometry = new TextGeometry('超かぐや姫!', {
            font: font,
            size: 0.5,
            depth: 0.2,
            curveSegments: 3,
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.01,
            bevelOffset: 0,
            bevelSegments: 1,
        });
        const material = new THREE.MeshMatcapMaterial({ map: matcapTexture });
        const text = new THREE.Mesh(textGeometry, material);
        scene.add(text);

        textGeometry.center();
        camera.position.set(0, 0, 5);
        camera.lookAt(0, 0, 0);
    });

    /**
     * Pancakes
     */
    // On prépare le décodeur Draco pour lire ton fichier de 6 Mo
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.7/');

    // On crée le GLTFLoader ET on lui attache Draco
    const gltfLoader = new GLTFLoader();
    gltfLoader.setDRACOLoader(dracoLoader);

    // Maintenant on charge ton gâteau avec ta méthode préférée (.clone)
    gltfLoader.load('/models/pancake.glb', (gltf) => {
        const pancakeModel = gltf.scene;

        for (let i = 0; i < 25; i++) {
            const pancake = pancakeModel.clone(true);

            pancake.position.x = (Math.random() - 0.5) * 5;
            pancake.position.y = (Math.random() - 0.5) * 5;
            pancake.position.z = (Math.random() - 0.5) * 5;

            pancake.rotation.x = Math.random() * Math.PI;
            pancake.rotation.y = Math.random() * Math.PI;

            const scale = Math.random() * 0.5 + 0.5;
            pancake.scale.set(scale, scale, scale);

            pancake.traverse((child) => {
            if (child.isMesh) {
                child.material.side = THREE.FrontSide;
            }
        });
        
        pancake.matrixAutoUpdate = false;
        pancake.updateMatrix();

            scene.add(pancake);
        }
    });

    // Controls
    const controls = new OrbitControls(camera, canvas);
    controls.enableDamping = true;
    controls.minDistance = 2;
    controls.maxDistance = 7;
    controls.maxPolarAngle = Math.PI / 1.5;

    /**
     * Renderer
     */
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true
    });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(1);

    /**
     * Resize handler
     */

    const updateSizes = () => {
        // On prend la largeur du parent ou de la fenêtre
        const containerWidth = canvas.parentElement.clientWidth;
        const width = Math.min(containerWidth, 700);

        sizes.width = width;
        sizes.height = width; // Pour garder le format carré 1:1

        // Mise à jour de la caméra
        camera.aspect = sizes.width / sizes.height;
        camera.updateProjectionMatrix();

        // Mise à jour du rendu
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    };
    updateSizes();

    window.addEventListener('resize', updateSizes);

    /**
     * Animate
     */
    let animationId;

    const tick = () => {
    controls.update();
    renderer.render(scene, camera);

    // if (renderer.info.render.triangles > 0) {
    //     console.log("Triangles réels :", renderer.info.render.triangles);
    //     console.log("Draw calls réels :", renderer.info.render.calls);
    // }

    animationId = window.requestAnimationFrame(tick);
};

    tick();

    return () => {
        console.log("Nettoyage de la scène Three.js...");
        window.removeEventListener('resize', updateSizes);
        cancelAnimationFrame(animationId);
        
        renderer.dispose();
        scene.traverse((object) => {
            if (!object.isMesh) return;
            object.geometry.dispose();
            if (object.material.isMaterial) {
                object.material.dispose();
            } else if (Array.isArray(object.material)) {
                object.material.forEach(mat => mat.dispose());
            }
        });
    };
}